import * as z from 'zod';
import { revenueRecognitionSchema, accountingStandardSchema, periodTypeSchema, financialPeriodPreparationMethodSchema } from '../../../../enums.mjs';
import { isoDateSchema } from '../../../opaque.mjs';

var ComponentsPresent;
(function (ComponentsPresent) {
    ComponentsPresent.schema = z.object({
        balanceSheet: z.boolean(),
        incomeStatement: z.boolean(),
        cashFlowStatement: z.boolean(),
        notes: z.boolean(),
        wipSchedule: z.boolean(),
        cpaReport: z.boolean(),
    });
})(ComponentsPresent || (ComponentsPresent = {}));
var AccountingPolicies;
(function (AccountingPolicies) {
    AccountingPolicies.schema = z.object({
        periods: z.array(z.object({
            periodType: periodTypeSchema,
            startDate: isoDateSchema.nullable(),
            endDate: isoDateSchema,
        })),
        accountingStandard: accountingStandardSchema.nullable(),
        revenueRecognition: revenueRecognitionSchema.nullable(),
        isConsolidated: z.boolean().nullable(),
        currency: z.string().nullable(),
    });
})(AccountingPolicies || (AccountingPolicies = {}));
var OrganizationalStructure;
(function (OrganizationalStructure) {
    OrganizationalStructure.schema = z.object({
        consolidatedEntities: z.array(z.string()),
        nonConsolidatedEntities: z.array(z.string()),
    });
})(OrganizationalStructure || (OrganizationalStructure = {}));
var GeneralNotes;
(function (GeneralNotes) {
    GeneralNotes.schema = z.object({
        priorPeriodRestatement: z.boolean(),
        goingConcernDoubt: z.boolean(),
    });
})(GeneralNotes || (GeneralNotes = {}));
var StatementMetadata;
(function (StatementMetadata) {
    StatementMetadata.schema = z.object({
        isFinancialDocument: z.boolean(),
        componentsPresent: ComponentsPresent.schema,
        hasCpaReport: z.boolean(),
        cpaName: z.string().nullable(),
        companyName: z.string().nullable(),
        statementDate: isoDateSchema.nullable(),
        statementType: financialPeriodPreparationMethodSchema.nullable(),
        relatedParties: z.array(z.string()),
        accountingPolicies: AccountingPolicies.schema,
        organizationalStructure: OrganizationalStructure.schema,
        generalNotes: GeneralNotes.schema,
        multiPeriod: z.boolean(),
        reasoning: z.string().nullish(),
    });
})(StatementMetadata || (StatementMetadata = {}));

export { AccountingPolicies, ComponentsPresent, GeneralNotes, OrganizationalStructure, StatementMetadata };
